// 26.1.10 Reflect.isExtensible(target)
var $def          = require('./$.def')
  , anObject      = require('./$.an-object')
  , _isExtensible = Object.isExtensible || require('./$.is-object');

$def($def.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    return _isExtensible(anObject(target));
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/es6.reflect.is-extensible.js
 ** module id = 144
 ** module chunks = 0
 **/